import { getCookie } from 'cookies-next/client'

import { COOKIE_NAME_USER_CONSENT } from './cookieNames'

const COOKIE_NAME_MARKETING_STORAGE = 'ad_storage'

export const cookiesIsUserConsentForAnalyticsGranted = (): boolean => {
  const consentCookie = getCookie(COOKIE_NAME_USER_CONSENT)

  if (typeof consentCookie !== 'string') {
    return false
  }

  // eslint-disable-next-line unicorn/try-complexity -- don't reference, refactor if touched
  try {
    const consent = JSON.parse(consentCookie) as Partial<
      Record<string, boolean | number>
    >
    const analyticsStorageValue = consent[COOKIE_NAME_MARKETING_STORAGE]

    /**
     * For non-com tenants the truthy value is 1 instead of true
     * See: https://jira.shop-apotheke.com/browse/RMADT-3495
     */
    return analyticsStorageValue === true || analyticsStorageValue === 1
  } catch {
    return false
  }
}
